export default __webpack_public_path__ + "static/media/case-script.3c1f72b6.svg";